import { Post } from './index'


export const qryCategory = params => Post('/api/notice/qryCategory', params)

export const qryNoticeDetail = params => Post('/api/notice/qryNoticeDetail', params)

export const qrtNoticeTop = params => Post('/api/notice/top', params)